import CryptoJS from 'crypto-js';

/*
 * @Author: Administrator
 * @Date:   2019-08-27 09:56:12
 * @Last Modified by:   Administrator
 * @Last Modified time: 2019-12-25 11:17:16
 */

/**
 * 存储sessionStorage
 */
export const setSessionStore = (name, content) => {
    if (!name) {
        return;
    }
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
};

/**
 * 获取sessionStorage
 */
export const getSessionStore = name => {
    if (!name) {
        return;
    }
    return window.sessionStorage.getItem(name);
};

/**
 * 删除sessionStorage
 */
export const removeSessionStore = name => {
    if (!name) {
        return;
    }
    window.sessionStorage.removeItem(name);
};


/**
 * 存储localStorage
 */
export const setLocalStore = (name, content) => {
    if (!name) {
        return;
    }
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getLocalStore = name => {
    if (!name) {
        return;
    }
    return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
export const removeLocalStore = name => {
    if (!name) {
        return;
    }
    window.localStorage.removeItem(name);
};

/**
 * 格式化时间戳
 */
export const formatDateTime = (timestamp, fmt) => {
    let date = new Date(timestamp),
        o = {
            'm+': date.getMonth() + 1, //月份
            'd+': date.getDate(), //日
            'h+': date.getHours(), //小时
            'i+': date.getMinutes(), //分
            's+': date.getSeconds(), //秒
            'q+': Math.floor((date.getMonth() + 3) / 3), //季度
            'S': date.getMilliseconds() //毫秒
        };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length));
        }
    }
    return fmt;
};


/**
 * 日期转化
 */
export const formatTime = (time, pattern) => {
    let y, m, d, h, i, s;

    if (!pattern) {
        if (time) {
            pattern = time;
        } else {
            pattern = 'yyyy-mm-dd hh:ii:ss';
        }
        time = null;
    }
    if (!time) {
        time = new Date();
    } else if (!(time instanceof Date)) {
        time = new Date(time);
    }
    y = time.getFullYear();
    m = time.getMonth() + 1;
    d = time.getDate();
    h = time.getHours();
    i = time.getMinutes();
    s = time.getSeconds();
    m < 10 && (m = '0' + m);
    d < 10 && (d = '0' + d);
    h < 10 && (h = '0' + h);
    i < 10 && (i = '0' + i);
    s < 10 && (s = '0' + s);
    return pattern.replace('yyyy', y).replace('mm', m).replace('dd', d).replace('hh', h).replace('ii', i).replace('ss', s);

};


/**
 * 根据区域id获取当前区域名称
 */
export const getAreaName = (id, areaList) => {
    let name = '';
    const getName = (arr) => {
        for (const item of arr) {
            if (item.id === Number(id)) {
                name = item.mergerName;
            } else if (item.children) {
                getName(item.children);
            }
        }
    };

    if (areaList instanceof Array && !name) {
        getName(areaList);
    }
    return name;
};


/**
 * 根据当前子id获取所有父id(地址栏回填用)
 */
export const getParentList = (companyId, companyList) => {
    let parentList = [], newArr = [companyId],
        parentListFun = (arr) => {
            arr.forEach((item) => {
                if (item.parent) {
                    let pid = item['parent'],
                        oid = item['id'];

                    parentList[oid] = pid;
                }
                if (item.children) {
                    parentListFun(item['children']);
                }
            });
        },
        findParent = (id) => {
            if (parentList[id]) {
                let pid = parentList[id];

                if (pid) {
                    newArr.unshift(pid);
                    findParent(pid);
                }
            }
        };

    parentListFun(companyList);
    findParent(companyId);
    return newArr;
};


/**
 * 根据日期返回警告提示
 */
export const isExpireFun = (day) => {
    if(!day) {
        return false;
    }
    let tips = false,
        date1 = new Date(day),
        date2 = new Date();

    date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    const diffTime = date1.getTime() - date2.getTime(),
        dateNum = diffTime / (24 * 60 * 60 * 1000);

    if(dateNum > 0 && dateNum < 30) {
        tips = true;
    }else if( dateNum == 0 || dateNum < 0){
        tips = true;
    }
    return tips;
};


/**
 * 加密
 * word 传入加密的字符串
 */
export const Encrypt = (word) => {
    let wordStr = JSON.stringify(word); //转换为字符串
    var srcs = CryptoJS.enc.Utf8.parse(wordStr),
        key = CryptoJS.enc.Utf8.parse('o7H8uIM2O5qv65l2'),
        encrypted = CryptoJS.AES.encrypt(srcs, key, {
            'mode': CryptoJS.mode.ECB,
            'padding': CryptoJS.pad.Pkcs7
        });

    return encrypted.toString();
};


/**解密
 * word 传入加密的字符串
 * */
export const Decrypt = (word) => {
    var key = CryptoJS.enc.Utf8.parse('o7H8uIM2O5qv65l2'),
        decrypt = CryptoJS.AES.decrypt(word, key, {
            'mode': CryptoJS.mode.ECB,
            'padding': CryptoJS.pad.Pkcs7
        });
    let decStr = CryptoJS.enc.Utf8.stringify(decrypt).toString();

    return JSON.parse(decStr); //解析为json字符串
};


export const aesMinEncrypt = (key, word) => {
    var password = word,
        key = CryptoJS.enc.Utf8.parse(key),//密钥，128位加密密钥为16位
        content = CryptoJS.enc.Utf8.parse(password),//需要加密的内容
        encrypted = CryptoJS.AES.encrypt(content, key, {'iv': key, 'mode': CryptoJS.mode.ECB, 'padding': CryptoJS.pad.Pkcs7}); //加密内容

    return encrypted.toString();
};


/**
 * sleep
 */
export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

/**
 * 去除对象中所有字符串属性的空格
 */
export const removeSpace = (parma,attribute) => {
    for(let i in parma){
        if(i === attribute) {
            continue;
        }
        if (typeof parma[i]==='string' && parma[i].constructor===String) {
            parma[i] =parma[i].replace(/\s*/g,'');
        }
    }
    return parma;
};
